import React from 'react';
import Analytics from '../../../lib/user-analytics';
import { SitemapLink } from './footer';

const CompanyLinks = () => {
    const onClickAbout = () => {
        Analytics.Event('LandingPage', 'Clicked footer about');
        window.open('https://about.soar.earth', '_blank');
    };

    const onClickMeetTheTeam = () => {
        Analytics.Event('LandingPage', 'Clicked footer meet the team');
        window.open('https://about.soar.earth/team.html', '_blank');
    };

    const onClickPress = () => {
        Analytics.Event('LandingPage', 'Clicked footer press');
        window.open('https://about.soar.earth/press.html', '_blank');
    };

    return (
        <React.Fragment>
            <SitemapLink title="About" onClick={onClickAbout}>
                About
            </SitemapLink>
            <SitemapLink title="Meet the team" onClick={onClickMeetTheTeam}>
                Meet the team
            </SitemapLink>
            <SitemapLink title="Press" onClick={onClickPress}>
                Press
            </SitemapLink>
        </React.Fragment>
    );
};

export default CompanyLinks;
